module.exports = "<footer class=\"flex flex-center flex-between\">\n  <div>© {{ currentYear }} B+A All Rights Reserved.</div>\n  <!--<div>-->\n    <!--<a>Terms & Conditions</a> | <a>Privacy Policy</a>-->\n  <!--</div>-->\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/footer/footer.component.html
// module id = ./src/app/footer/footer.component.html
// module chunks = main